import {makeStyles} from "@material-ui/core";
import {Colors} from "../../../styles/Colors";
import {ReactNode} from "react";

export const useStyles = makeStyles(() => ({
    widgetContainer: {
        border: '1px solid rgba(221, 225, 231, 1)',
        borderRadius: 4,
        height: 'fit-content',
        width: 'fit-content',
        userSelect: 'none',
        '&:not(:last-child)': {
            marginBottom: 24,
        },
    },
    widgetHeader: {
        borderBottom: '1px solid rgba(221, 225, 231, 1)',
        background: Colors.White,
        height: 40,
        padding: '8px 24px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 'calc(480px - 50px)',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
    },
    label: {
        color: Colors.Secondary1,
        fontWeight: 500,
        fontSize: 16,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: 8,

        '&:hover': {
            opacity: 0.7,
        },
    },
    headerIconContainer: {
        marginRight: 8
    },
    iconButton: {
        '&:hover': {
            backgroundColor: Colors.SmokeBackground,
        },
    },
    widgetContent: {
        height: 'fit-content',
        background: Colors.White,
        overflowX: 'hidden',
        overflowY: 'auto',
        maxHeight: 504,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
    },
}));

export type AccountDashboardWidgetBaseProps = {
    customClasses?: {
        header?: string
    },
    route: string,
    icon: ReactNode,
    label: string,
    customWidgetContainerClass?: string,
    customWidgetContentClass?: string,
};